import { useDataValue, useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_phone',
  })
  let persons = useDataValue({
    context: 'same_phone_persons',
    viewPath: props.viewPath,
  })
  return function useOnClick(value) {
    submit({
      type: 'phone_for_patient',
      contact_method_id: persons?.[0].contact_method_id,
    })
  }
}
